// extracted by mini-css-extract-plugin
module.exports = {"screen":"ArticleDetail_screen_LUDAk","article":"ArticleDetail_article_3EQgr"};